// Context pour gérer le mode de navigation (Shop / Réseau / Pro)
// Persiste le choix de l'utilisateur dans localStorage

import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NavModeContext = createContext();

export const NAV_MODES = {
  SHOP: 'shop',
  RESEAU: 'reseau',
};

const STORAGE_KEY = 'abracada_nav_mode';

export function NavModeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    // Récupérer le mode sauvegardé au chargement
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && Object.values(NAV_MODES).includes(saved)) {
        return saved;
      }
    }
    return NAV_MODES.SHOP; // Mode par défaut
  });

  // Sauvegarder dans localStorage quand le mode change
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  const setMode = (newMode) => {
    if (Object.values(NAV_MODES).includes(newMode)) {
      setModeState(newMode);
    }
  };

  const toggleMode = () => {
    setModeState(prev => prev === NAV_MODES.SHOP ? NAV_MODES.RESEAU : NAV_MODES.SHOP);
  };

  const isShopMode = mode === NAV_MODES.SHOP;
  const isReseauMode = mode === NAV_MODES.RESEAU;

  return (
    <NavModeContext.Provider value={{ 
      mode, 
      setMode, 
      toggleMode,
      isShopMode,
      isReseauMode,
      NAV_MODES 
    }}>
      {children}
    </NavModeContext.Provider>
  );
}

export function useNavMode() {
  const context = useContext(NavModeContext);
  if (!context) {
    throw new Error('useNavMode must be used within a NavModeProvider');
  }
  return context;
}

export default NavModeContext;
